// Substituto Werc do registro de atalhos do Macro (que puxa telemetria e 400+ comandos).
// O app registra os próprios atalhos; o <Hotkey token="..."/> do Macro mostra o texto bonito.
import type { HotkeyToken } from './tokens'

const atalhos = new Map<HotkeyToken, string>()

/** Ex.: registrarAtalho('abrir-comandos', 'cmd+k') */
export function registrarAtalho(token: HotkeyToken, teclas: string): void {
  atalhos.set(token, teclas)
}

const ehMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform)
const NOMES: Record<string, string> = ehMac
  ? { cmd: '⌘', ctrl: '⌃', alt: '⌥', shift: '⇧', enter: '↩', escape: 'Esc' }
  : { cmd: 'Ctrl', ctrl: 'Ctrl', alt: 'Alt', shift: 'Shift', enter: 'Enter', escape: 'Esc' }

export function prettyPrintHotkeyString(teclas: string): string {
  return teclas
    .split('+')
    .map((t) => NOMES[t.toLowerCase()] ?? t.toUpperCase())
    .join(ehMac ? '' : '+')
}

export function getPrettyHotkeyStringByToken(token: HotkeyToken): string | undefined {
  const teclas = atalhos.get(token)
  return teclas ? prettyPrintHotkeyString(teclas) : undefined
}
